import $ from 'jquery';
import EFOcats_event_core from '../../../core/v2/event/efocats_event_core.js';

/**
 * パスワード欄表示
 */
export default class EFOcats_event_modal extends EFOcats_event_core {
  constructor() {
    super();
    this.current_scrollY = 0;
    this.timer = 0;
    this.analyticsTimer = 0;

    this.open = false;

    // ページ下に留まるとモーダルが再度開くので閉じる時に調整する
    this.scrollblock = 850;

    $('#cat-dummy-layer').hide();
  }

  /**
   * イベント本体をセット
   */
  event() {
    // 表示ボタンクリック
    $('body').on('click', '.efocats_on', () => {
      this.showExtentionModal();
      return false;
    });

    // 再表示ボタンクリック
    $('.efocats_reshow').on('click', () => {
      $('.cat-modal,.cat-modal-bg').hide();
      $('.cat-modal,.cat-modal-bg').css({
        transform: 'translateY(120%) ',
        opacity: 0,
      });

      this.showSlideUpModal();

      return false;
    });

    // 閉じるクリック
    $('.efocats_off').on('click', () => {
      $('body').removeAttr('style');

      $(window).scrollTop(this.current_scrollY);

      $('.cat-modal,.cat-modal-bg').hide();

      $('.cat-modal,.cat-modal-bg').css({
        transform: 'scale(0.0)',
        opacity: 0,
      });

      $('.cat-modal-reshow').show();
      $('.cat-modal-reshow-icon').show();
      $('.sec02,.sec03,.sec06').show();

      // 分析データのタイマーを止める
      efocats.clearInterval(this.analyticsTimer);
      efocats.submit.stop_time_all();

      this.open = false;

      return false;
    });

    // ページ下部までスクロール
    $(window).on('scroll', () => {
      const doch = $(document).innerHeight();
      const winh = $(window).innerHeight();
      const bottom = doch - winh - 90;

      // 3秒間ページ下部にいる場合だけモーダルを表示
      if (bottom <= $(window).scrollTop()) {
        if (this.timer === 0) {
          if ($('.cat-modal').css('display') === 'none') {
            $('.cat-modal,.cat-modal-bg').hide();
            $('.cat-modal,.cat-modal-bg').css({
              transform: 'translateY(120%) ',
              opacity: 0,
            });

            this.timer = efocats.setInterval(() => {
              efocats.clearInterval(this.timer);
              this.timer = 0;
              this.showSlideUpModal();
              this.current_scrollY = bottom - this.scrollblock;
            }, efocats.show_modal_time);
          }
        }
      } else if (this.timer > 0) {
        efocats.clearInterval(this.timer);
        this.timer = 0;

        $('.cat-modal,.cat-modal-bg').hide();

        $('.cat-modal,.cat-modal-bg').css({
          transform: 'scale(0,0) translateY(0)',
          opacity: 0,
        });
      }
    });

    $(window).on('popstate', event => {
      if (this.open) {
        $(window).scrollTop(this.current_scrollY);
        window.history.pushState(null, null, null);
        $('.efocats_off').trigger('click');
      } else {
        window.history.go(-1);
      }
    });

    window.history.pushState(null, null, null);
  }

  /**
   * 表示（スライドアップ）
   */
  showSlideUpModal() {
    this.current_scrollY = $(window).scrollTop();

    $('.cat-modal,.cat-modal-bg').show({
      done: () => {
        $('.cat-modal,.cat-modal-bg').css({
          transform: 'translateY(0)',
          opacity: 1,
        });

        this.hideArea();
        this.scrollPage();

        // 分析データ用のタイマーをスタート
        this.timer_on();
        efocats.submit.start_time_all();
        efocats.open_modal = true;

        // 可変対策
        this.setHeight();

        $('#cat-dummy-layer').show();

        this.open = true;
      },
    });
  }

  /**
   * 可変対策
   */
  setHeight() {
    this.$('.cat-wrapper').height($('.cat-modal-content').height() - $('.cat-modal-close').height() - this.$('.navgater-num').height());
  }

  /**
   * 分析データ用のタイマーをスタート
   */
  timer_on() {
    if (this.analyticsTimer > 0) {
      efocats.clearInterval(this.analyticsTimer);
    }
    this.analyticsTimer = efocats.setInterval(efocats.submit.countup, 1000);
  }

  /**
   * 表示（拡大）
   */
  showExtentionModal() {
    if ($('.cat-modal').css('display') === 'none') {
      this.current_scrollY = $(window).scrollTop();

      this.hideArea();

      $('.cat-modal,.cat-modal-bg').show({
        done: () => {
          $('.cat-modal,.cat-modal-bg').css({
            transform: 'scale(1,1) translateY(0)',
            opacity: 1,
          });

          this.scrollPage();

          // 分析データ用のタイマーをスタート
          this.timer_on();
          efocats.submit.start_time_all();
          efocats.open_modal = true;

          // 可変対策
          this.setHeight();

          $('#cat-dummy-layer').show();

          this.open = true;
        },
      });
    }
  }

  /**
   * EFOcatsをアクティブなページまでスクロールする
   */
  scrollPage() {
    const section = this.$('.cat-section.action').eq(0);
    const position = section[0].offsetTop;
    this.$('.cat-wrapper > .cat-container').scrollTop(position);
  }

  /**
   * 元画面を隠す
   */
  hideArea() {
    $('body').css('overflow', 'hidden');
    $('.cat-modal-reshow').hide();
    $('.cat-modal-reshow-icon').hide();

    $('.sec02,.sec03,.sec06').hide();
  }
}
